// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3ipxh","spin":"Spinner_spin__2GWHa","container":"Spinner_container__qqeTD"};